import React from 'react';

// Lazy load components

const CreatePwd = React.lazy(() => import('../Components/Pages/Auth/CreatePwd'));
const ForgetPwd = React.lazy(() => import('../Auth/RecoverPwd/ForgotPassword'));
const ResetPwd = React.lazy(() => import('../Auth/RecoverPwd/ResetPassword'));
const OtpVerif = React.lazy(() => import('../Auth/RecoverPwd/OtpVerif'));
const Login = React.lazy(() => import('../Components/Pages/Auth/Login'));
const Maintenance = React.lazy(() => import('../Components/Pages/Auth/Maintenance'));
const RegisterWizardContainer = React.lazy(() => import('../Components/Pages/Auth/RegisterWizard'));
const RegisterStepThree = React.lazy(() => import('../Components/Pages/Auth/RegisterWizard/RegisterStepThree'));
const RegisterStepFour = React.lazy(() => import('../Components/Pages/Auth/RegisterWizard/RegisterStepFour'));
const UnlockUser = React.lazy(() => import('../Components/Pages/Auth/UnlockUser'));
const PaymentForm = React.lazy(() => import('../Auth/PaymentForm'));
const PrivacyPolicy = React.lazy(() => import('../Components/Pages/Privacy/PrivacyPolicy'));
const MagicLogin = React.lazy(() => import('../Auth/MagicLogin'));

const EmailVerif = React.lazy(() => import('../Components/Pages/Auth/EmailVerif'));

export const authRoutes = [
  { path: `/auth/login`, Component: Login },
  { path: `/auth/magic-login/:token`, Component: MagicLogin },
  { path: `/auth/onboarding`, Component: RegisterWizardContainer },
  { path: `/auth/register/educational-level`, Component: RegisterStepThree },
  { path: `/auth/register/billing`, Component: RegisterStepFour },
  { path: `/pages/authentication/unlock-user`, Component: UnlockUser },
  { path: `/pages/authentication/create-pwd`, Component: CreatePwd },
  { path: `/auth/maintenance`, Component: Maintenance },
  { path: `/auth/verify-email/:token`, Component: EmailVerif },
  { path: `/auth/forget-pwd`, Component: ForgetPwd },
  { path: `/auth/otp-verify`, Component: OtpVerif },
  { path: `/auth/reset-pwd/:token`, Component: ResetPwd },
  { path: `/auth/checkout`, Component: PaymentForm },
  { path: `/privacy-policy`, Component: PrivacyPolicy },
];